import { render, staticRenderFns } from "./DisputeWithVoiceModal.vue?vue&type=template&id=6beeff7a"
import script from "./DisputeWithVoiceModal.vue?vue&type=script&lang=js"
export * from "./DisputeWithVoiceModal.vue?vue&type=script&lang=js"
import style0 from "./DisputeWithVoiceModal.vue?vue&type=style&index=0&id=6beeff7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports